import { useForm } from '@deadcow-enterprises/react-forms';
import { ErrorCodes, type NOSIDError } from '@nosinovacao/nosid-mfe-common';
import { useServicesContext } from './context';
import {
  useCommitAssociation,
  useSendAccountAssociationCode,
} from '@/hooks/api/account-association.hooks';
import { type AxiosError } from 'axios';
import { CodeInputLight } from '@/components/code-input/code-input.light';

export function ServicesNavSheetCodeInputContent() {
  const { flowData, setFlow } = useServicesContext();
  const { mutateAsync: commitAssociation } = useCommitAssociation();
  const {
    mutateAsync: sendCode,
    captcha,
    isPending: resendLoading,
  } = useSendAccountAssociationCode();
  const form = useForm({
    code: {
      value: '',
    },
  });

  function handleResend() {
    if (captcha.challenge && !captcha.token) return;
    sendCode({
      captcha,
      contactId: flowData.contactId,
      targetId: flowData.selectedContact,
      type: flowData.associationType,
    });
  }
  async function handleSubmit({ code }: { code: string }) {
    try {
      const result = await commitAssociation({
        code,
        contactId: flowData.contactId,
        targetId: flowData.selectedContact,
        type: flowData.associationType,
      });
      setFlow('success', {
        ...flowData,
        services: result,
      });
    } catch (err) {
      const errorCode = (err as AxiosError<NOSIDError>).response?.data?.ErrorCode;
      if (errorCode !== ErrorCodes.InvalidSecurityCode) return;

      form.addError('code', 'Services.AddServices.CodeInput.Errors.InvalidSecurityCode');
    }
  }

  return (
    <CodeInputLight
      translations={{
        resendCode: 'Services.AddServices.CodeInput.Resend',
        confirm: 'Services.AddServices.CodeInput.Submit',
      }}
      codeValue={form.value.code}
      codeId={form.ids.code ?? 'validate-contact-otp'}
      codeErrors={form.errors.code}
      isValidating={form.loading}
      isSending={resendLoading}
      captchaChallenge={captcha.challenge}
      onCaptchaChange={captcha.setToken}
      onCodeChange={(v) => form.setValue('code', v)}
      onResend={handleResend}
      onSubmit={form.handleSubmit(handleSubmit)}
    />
  );
}
